import { observer } from 'mobx-react-lite';
import React from 'react';
import { mergeSx } from '@jucy-ui/appearance';
import { Site } from '@jucy/rentals-api-client';
import { BoxProps } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { TypographyProps } from '@mui/material/Typography/Typography';
import { format } from 'date-fns';
import { Diff } from '../../Diff';

export interface TripInfoLocationDateSummaryProps {
    title: React.ReactNode;
    date?: Date;
    site?: Site;
    amendedDate?: Date;
    amendedSite?: Site;
    componentProps?: {
        root?: BoxProps;
        title?: TypographyProps;
        date?: TypographyProps & { format?: string };
        site?: TypographyProps;
        time?: TypographyProps & { format?: string };
    };
}

export const TripInfoLocationDateSummary: React.FC<TripInfoLocationDateSummaryProps> = observer(function TripInfoLocationDateSummaryComponent({
    title,
    date,
    site,
    amendedDate,
    amendedSite,
    componentProps,
}) {
    const dateFormat = componentProps?.date?.format || 'dd MMM yyyy';
    const timeFormat = componentProps?.time?.format || 'h:mm aaa';

    return (
        <Box {...componentProps?.root}>
            <Typography
                variant="subtitle2"
                component="h4"
                {...componentProps?.title}
                sx={mergeSx(
                    {
                        fontWeight: 300,
                    },
                    componentProps?.title?.sx
                )}
            >
                {title}
            </Typography>
            <Typography
                variant="subtitle2"
                component="div"
                {...componentProps?.date}
                sx={mergeSx(
                    {
                        fontWeight: '600',
                    },
                    componentProps?.date?.sx
                )}
            >
                <Diff oldValue={date && format(date, dateFormat)} newValue={amendedDate && format(amendedDate, dateFormat)} />
            </Typography>
            <Typography variant="body2" component="div" {...componentProps?.site}>
                <Diff oldValue={site?.name} newValue={amendedSite?.name} />
            </Typography>
            <Typography variant="body2" component="div" {...componentProps?.time}>
                <Diff oldValue={date && format(date, timeFormat)} newValue={amendedDate && format(amendedDate, timeFormat)} />
            </Typography>
        </Box>
    );
});
